import { Button, CardContent, IconButton, styled, Tooltip, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ResponsiveIframe from "../../../../../components/Common/ResponsiveIframe/ResponsiveIframe";

interface IProps {
    url: string;
    category?: string;
    backBtnCallback?: (e) => void;
    isSelected: boolean;
    setOrderList?: any;
    currentProductId?: string | number;
    addToOrdercallback?: (e) => void;
    openExampleReportCB: () => void;
    showAddToOrderBtn?: boolean;
}

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    "&:last-child": { paddingBottom: "15px" },
}));

const HeaderContainer = styled("div")(({ theme }) => ({
    flexBasis: "45%",
    backgroundColor: theme.palette.surface?.inverse,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.5rem 0.5rem 0.5rem 1rem",
}));

const HeaderText = styled(Typography)(({ theme }) => ({
    fontSize: "0.75rem",
    textTransform: "uppercase",
    color: theme.palette.common.white,
}));

const TestProductsIframe: FC<IProps> = ({
    url,
    category,
    backBtnCallback,
    isSelected,
    setOrderList,
    currentProductId,
    addToOrdercallback,
    openExampleReportCB,
    showAddToOrderBtn = true,
}) => {
    const [str, setStr] = useState("");

    const handleAddOrRemove = (e) => {
        if (isSelected) {
            if (setOrderList) {
                setOrderList((prev) => {
                    const newOrderList = prev?.filter((item: any) => {
                        if (item?.testProduct?.id === currentProductId) {
                            return false;
                        }
                        return true;
                    });
                    return newOrderList;
                });
            }
        } else if (addToOrdercallback && !isSelected) {
            addToOrdercallback(e);
        }
    };

    useEffect(() => {
        fetch(url)
            .then((res) => res.text())
            .then((res) => setStr(res));
    }, [url]);

    return (
        <StyledCardContent>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", paddingBottom: "5px" }}>
                <HeaderContainer>
                    <HeaderText variant="h6" align="left" sx={{ fontWeight: 700 }}>
                        {category || "test.category"}
                    </HeaderText>
                    <Tooltip
                        title={<FormattedMessage id="icon-button.tooltip.view-example-results-report" defaultMessage="View an example results report" />}
                        placement="top"
                        arrow
                    >
                        <IconButton onClick={openExampleReportCB} aria-label="Open example report">
                            <UploadFileIcon sx={{ color: "common.white" }} fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </HeaderContainer>

                <div>
                    {showAddToOrderBtn ? (
                        <Button
                            size="medium"
                            variant="outlined"
                            color="primary"
                            disableElevation
                            onClick={handleAddOrRemove}
                            sx={(theme) => ({
                                color: theme.palette.ink?.soft,
                                borderColor: theme.palette.merigold?.main,
                                borderRadius: "1.5625rem",
                                padding: "1rem 1.25rem",
                                fontSize: "0.875rem",
                                lineHeight: 1.2,
                                "&:hover": {
                                    borderColor: theme.palette.merigold?.main,
                                    background: theme.palette.merigold?.main,
                                },
                            })}
                        >
                            {isSelected ? (
                                <FormattedMessage id="common.button-label.remove" defaultMessage="Remove" />
                            ) : (
                                <FormattedMessage id="common.button-label.add-to-order" defaultMessage="Add to Order" />
                            )}
                        </Button>
                    ) : null}
                    {backBtnCallback ? (
                        <Button
                            size="medium"
                            variant="text"
                            color="primary"
                            disableElevation
                            onClick={(e) => backBtnCallback(e)}
                            sx={{ margin: "0 5px 0px 0 !important" }}
                        >
                            <FormattedMessage id="templating-header.button.back-to-search" defaultMessage="< Back to search" />
                        </Button>
                    ) : null}
                </div>
            </div>
            <div>
                <ResponsiveIframe title="Preview" srcDoc={str} />
            </div>
        </StyledCardContent>
    );
};

export default TestProductsIframe;
